import { DeviceType } from "common/types";
import { t } from "i18next";
import moment from "moment";
import { longMonthNames } from "nodeDetails/functions/dateFunctions";

export const getSensorTypeNameOnDeviceType = (deviceType: DeviceType) => {
  switch (deviceType) {
    case DeviceType.Leakage:
      return t("Leak detector");
    case DeviceType.Smoke:
      return t("Fire alarm");
  }
};

export const formatUnixToDateString = (unix: number) => {
  const date = moment.unix(unix);
  return `${date.date()} ${
    longMonthNames[+date.month()]
  } ${date.year()} ${date.hour()}:${("0" + date.minutes()).slice(
    -2
  )}:${date.second()}`;
};
